module.exports = __webpack_public_path__ + "static/media/p2008vid.e18ecf6b.mp4";